import React from "react";
import "./about.css";
import bluehubAbout from "../../assets/images/bluehubAbout.png";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-scroll";
import { IoArrowRedoOutline } from "react-icons/io5";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const container = React.useRef(null);
  useGSAP(
    () => {
      const timeline = gsap.timeline({
        delay: 0.5,
        scrollTrigger: {
          trigger: container.current,
          start: "20% bottom",
          end: "bottom top",
        },
      });

      timeline
        .from(".company__photo", { x: -50, opacity: 0 })
        .from(".title", {
          y: -50,
          opacity: 0,
        })
        .from(".sub__title", {
          y: -50,
          opacity: 0,
        })
        .from(".box", {
          x: 50,
          opacity: 0,
          stagger: 0.5,
        })
        .from(".description", {
          y: 50,
          opacity: 0,
        })
        .from(".group", {
          y: 50,
          opacity: 0,
        })
        .from(".buttons__container", {
          y: 50,
          opacity: 0,
        });
    },
    { scope: container }
  );

  return (
    <section id="about" ref={container}>
      <div className="container">
        <div className="column company__photo">
          <img src={bluehubAbout} alt="Company Photo" />
        </div>
        <div className="column">
          <h1 className="title">
            <span className="g-text">About Us</span>
          </h1>

          <p className="muted__description">
            <span>BLUEHUB INDUSTRIES</span> is a Packaging materials and general
            merchandise supplies company. It was founded 13 years ago and
            providing packaging solutions to over 10,400 across the Country as
            well as overseas in Netherlands, Sudan, Mogadishu, USA and Rwanda.
          </p>

          <p className="muted__description">
            Our offices and factory are located along Waiyaki Way at Kinoo
            Shopping Centre. Our main focus is effective and efficient provision
            of Packaging materials, general branding services and supplies to
            both private and government sectors. It puts together the efforts of
            young minds, with great interpersonal skills and versatility to
            perform duties. Bluehub Industries aims at provision of a wide
            variety of goods and services and in the process, add value to
            peoples' lives.
          </p>

          <p className="muted__description">
            At Bluehub Industries, we realize that our customers have many
            options when selecting a packaging partner. We are committed to
            being suppliers of choice. The services we provide are beyond doubt
            and our staff are driven by customer satisfaction.
          </p>

          <div className="company__core__container">
            <div className="core_card">
              <div className="core_card_head">
                <h1 className="core_title">Our Vision</h1>
              </div>
              <div className="core_card_content">
                <p>
                  To be a leader in the provision of design, branding, printing
                  and marketing solutions in Kenya and beyond.
                </p>
              </div>
            </div>
            <div className="core_card">
              <div className="core_card_head">
                <h1 className="core_title">Our Mission</h1>
              </div>
              <div>
                <div className="core_card_content">
                  <p>
                    To deliver print/Brand-based packaging solutions which
                    maintains the success of our client's journey, through
                    combination of creativity in providing solutions and
                    maintaining quality.
                  </p>
                </div>
              </div>
            </div>
            <div className="core_card">
              <div className="core_card_head">
                <h1 className="core_title">Core Values</h1>
              </div>
              <div className="core_card_content">
                <ul style={{ listStyleType: "none" }}>
                  <li>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <IoArrowRedoOutline />
                      Transparency
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <IoArrowRedoOutline />
                      Competence
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <IoArrowRedoOutline />
                      Reliability
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <IoArrowRedoOutline />
                      Goal Oriented
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="group_header">
            <h1 className="group_header_title">Why Choose Us</h1>
          </div>
          <div className="group">
            <div className="row">
              <div className="icon__container">
                <FaCheck />
              </div>
              <div className="details">
                <p className="text__muted">Competitive Pricing</p>
                <h3>
                  We provide our clients with highest quality product at most
                  competitive prices
                </h3>
              </div>
            </div>

            <div className="row">
              <div className="icon__container">
                <FaCheck />
              </div>
              <div className="details">
                <p className="text__muted">Customized Services</p>
                <h3>
                  We involve our clients in every aspect to ensure customer
                  satisfaction
                </h3>
              </div>
            </div>

            <div className="row">
              <div className="icon__container">
                <FaCheck />
              </div>
              <div className="details">
                <p className="text__muted">Long-term partnership</p>
                <h3>
                  We aim to establish long-term partnerships with out clients
                </h3>
              </div>
            </div>

            <div className="row">
              <div className="icon__container">
                <FaCheck />
              </div>
              <div className="details">
                <p className="text__muted">Competent</p>
                <h3>Qualified Staff</h3>
              </div>
            </div>
          </div>
          {/* <div className="buttons__container">
            <Link to="project" smooth={true} className="btn">
              Explore
            </Link>
            <Link to="contact" smooth={true} className="btn btn__primary">
              Get a quote
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default About;
